/**
 * Check if the app is running in wrapper mode
 * @returns {string} The wrapper value from localStorage (default: "no")
 */
export const isWrapperMode = () => {
  return localStorage.getItem("wrapper") || "no";
};

/**
 * Get the kiosk path from localStorage
 * @returns {string|null} The kiosk path if set, null otherwise
 */
export const getKioskPath = () => {
  return localStorage.getItem("kioskPath");
};
